import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import { useOperationStore } from "@/stores/operation";
import { getFileData } from "@/libs/tools";
import PopupView from "@/components/PopupView.vue";
import PopupErrorView from "@/components/PopupErrorView.vue";
import LoadingPopupView from "@/components/LoadingPopupView.vue";
import { fetch } from "@/plugins/fetchPlugin";
import dayjs from "dayjs";
import "dayjs/locale/fr";

// eslint-disable-next-line no-undef
import Teleport from "vue2-teleport";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  props: {
  status: {
    type: String,
    required: true,
  },
  counterHome: {
    type: Object,
    required: false,
  },
},
  emits: ["direction", "setview"],
  setup(__props, { emit }) {

const props = __props;



// eslint-disable-next-line @typescript-eslint/no-unused-vars
const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
const logo = ref<{ filename: string; uri: string } | undefined>(undefined);
const active = ref(false);
const error = ref(false);
const email = ref("");
const loading = ref(false);

const date_debut = computed(() =>
  op.value ? dayjs(op.value.date_debut).locale("fr").format("DD MMMM YYYY") : ""
);
const date_fin = computed(() =>
  op.value ? dayjs(op.value.date_fin).locale("fr").format("DD MMMM YYYY") : ""
);



const bannerDirection = () => {
  emit("direction", "left");
};

const setView = (newPath: string) => {
  emit("setview", newPath);
};

//const fullOpen = () => {
//  emit("direction", "fullopen");
//};

//const slideToReset = () => {
//  emit("direction", "reset");
//};

const onSubmit = async () => {
  try {
    loading.value = true;
    if (!email.value) {
      loading.value = false;
      error.value = true;
      return;
    }

    const login = await fetch(
      `/api/operations-custom/fromscratch-platform/check`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          operation_id: operationStore?.operationData?._id,
          email: email.value,
        }),
      }
    );

    if (login && login?.id && login?.uid) {
      await fetch(`/api/v2/formdata/sendReminderEmail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          operationId: operationStore?.operationData?._id,
          email: email.value,
        }),
      });
      active.value = true;
      email.value = "";
      loading.value = false;
    } else {
      error.value = true;
      loading.value = false;
      return;
    }
  } catch (e) {
    error.value = true;
    loading.value = false;
    setTimeout(() => {
      emit("setview", "register");
      emit("direction", "left");
    }, 1000);
  }
};

onMounted(async () => {
  try {
    const files = operationStore?.filesData ?? [];
    logo.value = getFileData(files, "logo1");
  } catch (e) {
    console.error(e);
  }
});

return { __sfc: true,props, operationStore, op, logo, active, error, email, loading, date_debut, date_fin, emit, bannerDirection, setView, onSubmit, PopupView, PopupErrorView, LoadingPopupView, Teleport }
}

})